import React, { createContext, useContext, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { base44 } from "@/api/base44Client";

const PromotedCompaniesContext = createContext(null);

export function PromotedCompaniesProvider({ children }) {
  const hasToken = typeof window !== "undefined" && !!localStorage.getItem("auth_token");

  const { data, isSuccess, isError, error } = useQuery({
    queryKey: ["settings", "ui-labels"],
    queryFn: () => base44.entities.SystemSetting.getUiLabels(),
    staleTime: 0,
    retry: 2,
    refetchOnWindowFocus: true,
    refetchOnMount: "always",
    enabled: hasToken,
  });

  const value = useMemo(() => {
    if (isError && import.meta.env.DEV) {
      console.warn("[PromotedCompanies] getUiLabels failed:", error);
    }
    const ids =
      isSuccess && Array.isArray(data?.promotedCompanyIds)
        ? data.promotedCompanyIds.map(String)
        : [];
    return { promotedCompanyIds: ids, isLoading: hasToken && !isSuccess && !isError };
  }, [hasToken, data, isSuccess, isError, error]);

  return (
    <PromotedCompaniesContext.Provider value={value}>
      {children}
    </PromotedCompaniesContext.Provider>
  );
}

export function usePromotedCompanies() {
  const ctx = useContext(PromotedCompaniesContext);
  if (!ctx) {
    return { promotedCompanyIds: [], isLoading: false };
  }
  return ctx;
}
